import { PublicationCreate, PublicationRead } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";
import { ApiError } from "@nens/react-query-utils";

import { useInvalidatePublicationListQuery } from "@/queries/query-publication";

export function useCreatePublication() {
  const invalidatePublicationListQuery = useInvalidatePublicationListQuery();
  return useMutationWithErrorHandler<PublicationRead, ApiError, PublicationCreate>(
    async (props: PublicationCreate) => {
      const response = await getRanaApiV1().PublicationsApi.publicationCreate({
        publicationCreate: props,
      });

      // Refresh the publications list
      invalidatePublicationListQuery();

      return response;
    }
  );
}
